import React, { useEffect, useState } from "react";
import Navbar from "../components/helpers/Navbar";
import AddPetitionModal from "../components/petitii/AddPetitionModal";
import PetitionTable from "../components/petitii/PetitionTable";
import ExportButtons from "../components/petitii/ExportButtons";
import Footer from "../components/helpers/Footer";

const API_BASE = "https://prdp-api.suport-949.workers.dev/api/semnaturi";

// Token hardcodat pentru autentificare Bearer
const TOKEN = "unwantedtok";
const AUTH_HEADER = {
  Authorization: `Bearer ${TOKEN}`,
};

const Petitii = () => {
  const [petitii, setPetitii] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedPetitie, setSelectedPetitie] = useState(null);

  // Fetch petitii la montare
  useEffect(() => {
    const fetchPetitii = async () => {
      try {
        setLoading(true);
        const res = await fetch(API_BASE, {
          headers: AUTH_HEADER,
        });
        const data = await res.json();
        setPetitii(data);
      } catch (err) {
        console.error("Eroare la preluarea petițiilor:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPetitii();
  }, []);

  const savePetitie = async (petitie) => {
    try {
      if (selectedPetitie) {
        // Editare petiție
        const response = await fetch(`${API_BASE}/${selectedPetitie.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...AUTH_HEADER,
          },
          body: JSON.stringify(petitie),
        });
        if (!response.ok) throw new Error("Eroare la editarea petiției");

        setPetitii((prev) =>
          prev.map((p) => (p.id === selectedPetitie.id ? petitie : p))
        );
      } else {
        // Adăugare petiție nouă
        const response = await fetch(API_BASE, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...AUTH_HEADER,
          },
          body: JSON.stringify(petitie),
        });
        if (!response.ok) throw new Error("Eroare la adăugare petiție");

        const newPetitie = await response.json();
        setPetitii((prev) => [...prev, newPetitie]);
      }

      setShowModal(false);
      setSelectedPetitie(null);
    } catch (err) {
      console.error("Eroare la salvare:", err);
    }
  };

  const deletePetitie = async (id) => {
    try {
      const response = await fetch(`${API_BASE}/${id}`, {
        method: "DELETE",
        headers: AUTH_HEADER,
      });
      if (!response.ok) throw new Error("Eroare la ștergere petiție");

      setPetitii((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error("Eroare la ștergere:", err);
    }
  };

  const handleEdit = (petitie) => {
    setSelectedPetitie(petitie);
    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
    setSelectedPetitie(null);
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5">
        <h2 className="mb-4 text-center text-primary-dark">Listă Petiții</h2>

        <button
          className="btn btn-primary btn-primary-admin mb-3"
          onClick={() => setShowModal(true)}
        >
          Adaugă semnătură
        </button>

        {loading ? (
          <div className="text-center">Se încarcă...</div>
        ) : (
          <>
            <PetitionTable
              petitii={petitii}
              onDelete={(index) => deletePetitie(petitii[index].id)}
              onEdit={handleEdit}
            />
            <ExportButtons data={petitii} />
          </>
        )}

        <AddPetitionModal
          show={showModal}
          onHide={handleHideModal}
          onSave={savePetitie}
          initialData={selectedPetitie}
        />

        <Footer />
      </div>
    </div>
  );
};

export default Petitii;
